module.exports = __webpack_public_path__ + "img/autherror.8f41b97b.svg";